import {actionCreators as loadActionCreators} from '../../redux/actions/loadActions';

const LoadEventManager = {
  handlePageRenderStart(dispatch, page, dynamic) {
    if (process.env.BROWSER && document.readyState === 'complete') {
      dispatch(loadActionCreators.pageRenderStart({
        pageType: page,
        dynamic,
      }));
    }
  },

  handleDomLoaded(dispatch, page, dynamic) {
    if (process.env.BROWSER && document.readyState === 'complete') {
      dispatch(
        loadActionCreators.domLoaderEnd({
          pageType: page,
          dynamic,
        }),
      );
    }
  },

  handlePageRendered(dispatch) {
    if (process.env.BROWSER && document.readyState === 'complete') {
      dispatch(
        loadActionCreators.pageRenderEnd(),
      );
    }
  },
}

export default LoadEventManager;
